import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { message } from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import '@/styles/common.less'
import '@/styles/toast-fix.css'
// import '@/assets/css/font.css'
import '@/assets/css/markdown.min.css'
import './styles/reset.css'
import '@/styles/theme-v1.less'
import hevueImgPreview from 'hevue-img-preview'
import { watermarkDirective } from './utils/watermark'
import draggable from './directives/draggable'
import { moveDirectivePlugin } from 'lite-move'

// 配置 message 的全局属性
message.config({
  top: '100px',
  duration: 3,
  maxCount: 3,
  rtl: false,
  prefixCls: 'ant-message'
})

// import "tailwindcss/tailwind.css"
// 使用mitt库
import mitt from 'mitt'
const Mit = mitt()
window.$Bus = Mit

const app = createApp(App)

app.directive('watermark', watermarkDirective)

app.directive('draggable', draggable)

// 优化：异步挂载应用，避免阻塞
const mountApp = () => {
  app.use(router)
    .use(hevueImgPreview)
    .use(moveDirectivePlugin)
    .use(store)
    // .use(htmlToPdf)
    .mount('#app')
}

// 使用requestIdleCallback或setTimeout确保不阻塞渲染
if (window.requestIdleCallback) {
  window.requestIdleCallback(mountApp)
} else {
  setTimeout(mountApp, 0)
}
